import { COURSE_STRUCTURES } from 'constants/common';

import type { DisplayRow } from './CoursesLessonsPage.grouping';

export const getLessonRowModuleTitle = (
  item: DisplayRow,
): string | undefined => {
  if (
    item.groupCourse?.structure === COURSE_STRUCTURES.MODULES &&
    item.groupCourse.moduleTitle
  ) {
    return item.groupCourse.moduleTitle;
  }

  const modularCourseWithModule = item.courses.find(
    (course) =>
      course.structure === COURSE_STRUCTURES.MODULES && course.moduleTitle,
  );

  return modularCourseWithModule?.moduleTitle;
};
